import React, { useRef } from 'react';
import { DASHBOARD_SHAPE, EMBED_STATUS } from '../utils/dashboardHelpers';
import { useEmbedToken } from '../hooks/useEmbedToken';
import { usePowerBiEmbed } from '../hooks/usePowerBiEmbed';
import { DashboardLoadingOverlay } from './DashboardLoadingOverlay';
import { DashboardError } from './DashboardError';

export const DashboardEmbed = ({ dashboard }) => {
    const containerRef = useRef(null);
    const { getEmbedInfo } = useEmbedToken();

    const { status, statusText, error, retry } = usePowerBiEmbed({
        containerRef,
        reportId: dashboard.reportId,
        filters: dashboard.filters,
        getEmbedInfo,
    });

    const isLoading = status === EMBED_STATUS.REQUESTING || status === EMBED_STATUS.RENDERING;

    return (
        <div className="dashboard__embed-wrapper">
            <div ref={containerRef} className="dashboard__embed-container" />
            {isLoading && <DashboardLoadingOverlay statusText={statusText} />}
            {status === EMBED_STATUS.ERROR && <DashboardError message={error} onRetry={retry} />}
        </div>
    );
};

DashboardEmbed.propTypes = {
    dashboard: DASHBOARD_SHAPE.isRequired,
};
